
require('./style.scss')
class ScreenshotDirective
  @$inject: ["Lightbox"]
  constructor: (Lightbox)->
    class Screenshot      
      restrict: "A"
      bindToController:
        device: "="
      controllerAs: "$screenshot"
      controller: ($scope, $element, $attrs)->
        @screenshot = ()=>
          $scope.device.$screenshot().then (data)=>
            @data = data
        @preview = ()=>          
          opts = 
            url: "data:image/png;base64,#{@data}"          
          Lightbox.openModal [opts], 0
        return @
        


    return new Screenshot();

angular = require('angular')
require("angular-bootstrap-lightbox")
pkg = angular.module('cdms.device.screenshot', ["bootstrapLightbox"]) 
  .directive "screenshot", ScreenshotDirective 

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/screenshot/index.coffee